import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import '../../Styles/header.css';

export default class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isMenuOpen: false
    };
  }

  toggleMenu = () => {
    this.setState({ isMenuOpen: !this.state.isMenuOpen });
  };

  render() {
    return (
      <nav className="simple-header">
        <div className="header-container">
          <Link to="/" className="header-brand">
            <img 
              src="/assets/img/kairaly_logo.jpg" 
              alt="Kairaly Hotels & Holidays" 
              height="80"
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = "https://via.placeholder.com/50x50?text=K";
              }}
            />
            <div className='brand-text'>
            <span className="brand-name">Kairaly Hotels & Holidays</span>
            <span className="brand-tagline">KERALA GOVERNMENT ACCREDITED</span>
            </div>
          </Link>
          
          <button className="mobile-menu-btn" onClick={this.toggleMenu}>
            ☰
          </button>
          
          <div className={`header-nav-links ${this.state.isMenuOpen ? 'active' : ''}`}>
            <Link to="/" className="nav-link" onClick={this.toggleMenu}>Home</Link>
            <Link to="/about" className="nav-link" onClick={this.toggleMenu}>About</Link>
            <Link to="/services" className="nav-link" onClick={this.toggleMenu}>Services</Link>
            <Link to="/destinations" className="nav-link" onClick={this.toggleMenu}>Destinations</Link>
            <Link to="/packages" className="nav-link" onClick={this.toggleMenu}>Packages</Link>
            <Link to="/contact" className="nav-link" onClick={this.toggleMenu}>Contact</Link>
          </div>
        </div>
      </nav>
    );
  }
}